export const global = {
  "html, body": {
    fontFamily: "main",
  },
}
